// extracted by mini-css-extract-plugin
export default {"infoMessage":"InfoMessage_infoMessage--U5U","infoMessageColor":"InfoMessage_infoMessageColor--ASR","iconWrap":"InfoMessage_iconWrap--gCS"};